import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AppConfigProvider } from './app-config.provider';
import { PersistenceStorageService } from "./services/index";
import { AppToken } from "./models/app-token";

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {

    constructor(
        private readonly persistenceStorageService: PersistenceStorageService,
        private readonly appConfigProvider: AppConfigProvider,
        readonly translateService: TranslateService) {
    }

    ngOnInit(): void {
        this.initializeLocalization();
    }

    private initializeLocalization(): void {

        const availableLanguages = this.appConfigProvider.getAvailableLanguages();
        this.translateService.addLangs(availableLanguages);

        const userLanguage = this.persistenceStorageService.get(AppToken.USER_SAVE_CULTURE_CODE);

        if (userLanguage) {
            this.translateService.use(userLanguage).toPromise();
        } else {
            let defaultLanguage = this.appConfigProvider.getDefaultCulture();
            if (defaultLanguage) {
                this.translateService.setDefaultLang(defaultLanguage);
                this.persistenceStorageService.set(AppToken.USER_SAVE_CULTURE_CODE, defaultLanguage);
                this.translateService.use(defaultLanguage).toPromise();
            } else {
                const browserLang = this.translateService.getBrowserLang();
                if (browserLang) {
                    const l = browserLang.split('-')[0];
                    defaultLanguage = l.match(/en-CA|fr-CA/) ? browserLang : availableLanguages[0];
                    this.persistenceStorageService.set(AppToken.USER_SAVE_CULTURE_CODE, defaultLanguage);
                    this.translateService.use(defaultLanguage).toPromise();
                } else {
                    defaultLanguage = availableLanguages[0];
                    this.persistenceStorageService.set(AppToken.USER_SAVE_CULTURE_CODE, defaultLanguage);
                    this.translateService.use(defaultLanguage).toPromise();
                }
            }
        }
    }
}
